import React, { Component } from 'react';
import { Container, Row, Col, Pagination } from 'react-bootstrap';
import EventResults from '../components/event/EventResults';
import '../css/style.css';
import '../components/Home.css';
import { getURL } from '../backend/Backend';



class EventPagingLayout extends Component {

    constructor(props) {
        super(props);
        this.searchEvents = this.searchEvents.bind(this);
        this.pageChanged = this.pageChanged.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.goBack = this.goBack.bind(this);


        this.state = {
            events: [],
            selected: '',
            activePage: 1,
            totalPages: 0
        };
    }

    async componentDidMount() {
        this.searchEvents(1);
    }


    async pageChanged(e) {
        this.searchEvents(e.target.text);
    }

    async searchEvents(page) {
        if (!page) {
            return;
        }
        if ("<" === page) {
            page = --this.state.activePage;
        }
        if (">" === page) {
            page = ++this.state.activePage;
        }

        let url = this.props.eventStatus ? `${this.props.preURL}/${this.props.id}/${this.props.eventStatus}/${page - 1}`:
        `${this.props.preURL}/${this.props.id}/${page - 1}`;
        const response = await fetch(getURL(url));
        const json = await response.json();
        let oldState = this.state;
        this.setState({
            ...oldState,
            events: json.content,
            selected: '',
            totalPages: json.totalPages,
            activePage: page
        });

    }

    selectItem(e) {
        let oldState = this.state;

        this.setState({
            ...oldState,
            selected: e.id
        })
    }

    goBack() {
        let oldState = this.state;

        this.setState({
            ...oldState,
            selected: ''
        })
    }

    /*  <MyEvents events={this.state.events} selectItem={this.selectItem} edit={this.props.edit}/> */

    render() {
        return (
            <div >
                <Container fluid className="fluid container-fluid2">
                    <Row className="fluid container-fluid2" >
                        <Col   >
                            <div>
                                <EventResults events={this.state.events} />
                                <Pagination onClick={this.pageChanged}>
                                    {this.state.activePage > 1 ?
                                        <Pagination.Item>{'<'}</Pagination.Item>
                                        : ""
                                    }

                                    {[...Array(this.state.totalPages).keys()].map(i => {
                                        return <Pagination.Item active={(i + 1) === this.state.activePage} key={i} >{i + 1}</Pagination.Item>
                                    })
                                    }
                                    {this.state.activePage < this.state.totalPages ?
                                        <Pagination.Item>{'>'}</Pagination.Item>
                                        : ""
                                    }

                                </Pagination>
                            </div>

                        </Col>
                    </Row>
                 
                </Container>
            </div>
        );
    }

}

export default EventPagingLayout;